import { i18n } from "@lingui/core";
import React from 'react';
import './contact.scss';
import SEO from '../components/seo';
import Input from '../components/shared/form-elements/input/input';
import Button from '../components/shared/form-elements/button/button';
import { getAllLocaleUtils } from '../hooks/i18n-hook';

var ContactPage = function ContactPage() {
  var _getAllLocaleUtils = getAllLocaleUtils(),
      i18n = _getAllLocaleUtils.i18n,
      locale = _getAllLocaleUtils.locale;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: i18n._(
    /*i18n*/
    i18n._("Contact")),
    lang: locale
  }), /*#__PURE__*/React.createElement("div", {
    className: "contact-page"
  }, /*#__PURE__*/React.createElement("form", {
    name: "contact",
    method: "POST",
    "data-netlify": "true",
    action: "/" + locale + "/contact-success",
    "netlify-honeypot": "bot-field",
    className: "contact-form"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: "contact"
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("label", null, "Don\u2019t fill this out if you're human: ", /*#__PURE__*/React.createElement("input", {
    name: "bot-field"
  }))), /*#__PURE__*/React.createElement(Input, {
    element: "input",
    label:
    /*i18n*/
    i18n._("first name"),
    type: "text",
    name: "first-name",
    placeholder:
    /*i18n*/
    i18n._("kento")
  }), /*#__PURE__*/React.createElement(Input, {
    element: "input",
    label:
    /*i18n*/
    i18n._("last name"),
    type: "text",
    name: "last-name",
    placeholder:
    /*i18n*/
    i18n._("takeuchi")
  }), /*#__PURE__*/React.createElement(Input, {
    element: "input",
    label:
    /*i18n*/
    i18n._("email"),
    type: "email",
    name: "email",
    placeholder: "example@mail.com"
  }), /*#__PURE__*/React.createElement(Input, {
    element: "select",
    label:
    /*i18n*/
    i18n._("level"),
    name: "level",
    placeholder: "",
    options: [{
      name: 'beginner',
      value: 'beginner'
    }, {
      name: 'intermediate',
      value: 'intermediate'
    }, {
      name: 'advance',
      value: 'advance'
    }]
  }), /*#__PURE__*/React.createElement(Input, {
    element: "textarea",
    label:
    /*i18n*/
    i18n._("message"),
    name: "message",
    placeholder:
    /*i18n*/
    i18n._("feel free to ask anything or share your thought with me!")
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit"
  }, i18n._(
  /*i18n*/
  i18n._("submit"))))));
};

export default ContactPage;